import React from 'react';

const FormHeader = ({ titleRow1, titleRow2 }) => (
  <>
    <div className="form-header">
      <div className="header-text">
        <h2>{titleRow1}</h2>
        <h2>{titleRow2}</h2>
      </div>
      <hr />
    </div>
    <br />
  </>

);
export default FormHeader;